// Modules
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';

// Rxjs
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

// Constants
import { APP_PATHS_CONSTANTS } from '@shared/constants';

// Reducer
import { AppState } from '@store/reducers';

// Selectors
import * as AuthSelectors from '@store/selectors/auth.selectors';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard {
  // Constructor
  constructor(
    private _store: Store<AppState>,
    private _router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this._store.pipe(
      select(AuthSelectors.selectLoggedUser),
      map(user => {
        if (user) {
          this._router.navigateByUrl(APP_PATHS_CONSTANTS.ADMIN_PRIVATE_WRAPPER);
          return false;
        }

        return true;
      }),
      take(1)
    );
  }
}
